import { ReactComponent as LogoReducedSvg } from '@cobliteam/base-components/src/icons/logo-reduced.svg';
import type { Session, SessionUser } from '@cobliteam/common-types';

interface UserDataProps {
  session: Session;
  user: SessionUser;
  isCobler: boolean;
}

const UserDataComponent: React.FC<UserDataProps> = ({ session, user, isCobler }) => {
  return (
    <div>
      <h3 className='font-semibold text-lg'>Meus Dados</h3>
      {isCobler && (
        <p className='flex items-center gap-2 py-4 text-red-500'>
          <LogoReducedSvg />
          Você é um Cobler!
        </p>
      )}
      <p>
        <strong>ID:</strong> {user.id}
      </p>
      <p>
        <strong>Nome:</strong> {user.name}
      </p>
      <p>
        <strong>Email:</strong> {user.email}
      </p>
      <p>
        <strong>Role:</strong> {user.role}
      </p>

      <p>
        <strong>Fleet ID:</strong> {session.fleet.id}
      </p>
      <p>
        <strong>Fleet Name:</strong> {session.fleet.name}
      </p>
      <p>
        <strong>Conta criada em:</strong> {new Date(user.creationDate || 0).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
      </p>
    </div>
  );
};

export default UserDataComponent;
